import React, { useState, useRef, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { barcodeScanSeeWinner, claimWinningAmount } from '../apiService.js';
import WinnerPopup from './WinnerPopup.js';

const BarcodeInput = () => {
  const [barcode, setBarcode] = useState('');
  const inputRef = useRef(null);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [winnerDetails, setWinnerDetails] = useState(null);

  // Focus input on mount
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  // Handle input changes (manual typing + barcode scanner)
  const handleInputChange = (e) => {
    const value = e.target.value.trim(); // Trim any whitespace

    if (/^\d*$/.test(value) && value.length <= 8) {
      setBarcode(value);
    }
  };

  // Handle Enter keypress (barcode scanner triggers Enter after scanning)
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && barcode.length === 8) {
      checkWinner(barcode);
    }
  };

  // const checkWinner = async (barcode) => {
  //   try {
  //     const response = await barcodeScanSeeWinner(barcode);
  //     if (response.Status === 200) {
  //       toast.success("🎉 Congratulations! You are a winner!", {
  //         position: "top-center",
  //         autoClose: 5000,
  //         onClose: () => console.log("Success toast closed"), // Debugging
  //       });
  //     } 
  //   } catch (error) {
  //     console.error("An error occurred:", error);
  //     toast.error("Order not found. Please enter a valid order number.", {
  //       position: "top-center",
  //       autoClose: 5000,
  //     });
  //   }
  //   setBarcode('');  
  // };

  const checkWinner = async (barcode) => {
    try {
      const response = await barcodeScanSeeWinner(barcode);
      console.log("responseresponseresponse", response)
      if (response) {
        toast.success(response.text || response.message , {
          autoClose: 3500,
          // force this toast to render visually centered and large
          style: {
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '48px',
            textAlign: 'center',
            padding: '18px 26px',
            border: '5px solid #fff',
          color: '#fff',
            minWidth: '620px',
            zIndex: 99999
          }
        });
        setModalIsOpen(true);
        setWinnerDetails(response);
      }
    } catch (error) {
      console.error("An error occurred:", error);
      const msg = (error && (error.message || error.toString())) || 'Order not found';
      toast.error(msg, {
        autoClose: 3500,
        style: {
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: '42px',
          textAlign: 'center',
          padding: '14px 20px',
          minWidth: '560px',
          zIndex: 99999,
          background: '#8b0000',
          color: '#fff',
            border: '5px solid #fff',
        }
      });
      setBarcode("")
    }
  };

  const handleClaim = async () => {
    try {
      const claimResponse = await claimWinningAmount(barcode);
      toast.success(claimResponse.message);
      setModalIsOpen(false);
      setBarcode("")
    } catch (error) {
      console.error("Claim error:", error);
      toast.error("⚠️ Claim failed. Try again.", error);
      setModalIsOpen(false);
      setBarcode("")
    }
  };

  return (
    <div>
      <input
        style={{ color: 'white' }}
        type="text"
        ref={inputRef}
        placeholder="Scan or Enter Order Number"
        value={barcode}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
      />
      <WinnerPopup
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
        winnerDetails={winnerDetails}
        onClaim={handleClaim}
      />
    </div>
  );
};

export default BarcodeInput;
